export const properties = {
    BLOCKCHAIN_URL : 'http://54.229.157.131:4002',
    BLOCKCHAIN_EXPLORER: 'http://54.229.157.131:4050/#'
}




// WEBPACK FOOTER //
// ./src/environments.js